export default __webpack_public_path__ + "static/media/admin-logo.e8bbb433.svg";